import React, { useEffect, useRef, useState } from "react";
import { ItemType } from "antd/es/menu/interface";
import FlatList from "common/Lists/FlatList";
import BottomDrawer from "common/Drawers/BottomDrawer";
import styled from "styled-components";
import { DropdownProps } from "common/Dropdown/Dropdown";
import DropdownOption from "common/Dropdown/DropdownOption.tsx";
import useBackButtonHandler from "utils/hooks/useBackButtonHandler.ts";

const MobileDropdown = ({
  closeOnSelect = true,
  ...props
}: Omit<DropdownProps, "onOpenChange"> & {
  onOpenChange?: (open: boolean) => void;
  closeOnSelect?: boolean;
}) => {
  const [shouldCloseDrawer, setShouldCloseDrawer] = useState(false);
  const { registerBackButtonListener } = useBackButtonHandler();
  const closeSelectRef = useRef(props.onOpenChange);

  useEffect(() => {
    if (props.open) {
      return registerBackButtonListener(() => {
        closeSelectRef.current?.(false);
        return true;
      });
    }
  }, [props.open]);

  const renderOption = ({ item }: { item: ItemType }) => {
    return (
      <DropdownOption
        item={item}
        setShouldCloseDrawer={closeOnSelect ? setShouldCloseDrawer : undefined}
      />
    );
  };

  const content = (
    <FlatListWrapper>
      <FlatList
        data={props.menu?.items || []}
        renderContent={renderOption}
        wrapperStyle={{
          maxHeight: "70vh",
        }}
      />
    </FlatListWrapper>
  );

  return (
    <BottomDrawer
      content={content}
      title={props.title}
      triggerElement={props.children}
      contentStyle={{ padding: 0 }}
      shouldCloseDrawer={shouldCloseDrawer}
      setShouldCloseDrawer={setShouldCloseDrawer}
      className="mobile-dropdown"
      open={props.open}
      onOpenChange={props.onOpenChange}
    />
  );
};

export default MobileDropdown;

// A flex column so the list's own scroller shrinks to the capped sheet.
const FlatListWrapper = styled.div`
  width: 100%;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;
